var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWizzard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.706.47c0-.26.21-.47.47-.47h5.647c.26 0 .471.21.471.47v4.706c0 .26-.21.471-.47.471H8.47V7.53h4.233c.26 0 .47.211.47.471v2.353h2.355c.26 0 .471.21.471.47v4.706c0 .26-.21.471-.47.471H9.881a.47.47 0 01-.47-.47v-4.707c0-.26.21-.47.47-.47h2.351V8.47H3.764v1.882h2.355c.26 0 .47.21.47.47v4.706c0 .26-.21.471-.47.471H.47A.47.47 0 010 15.53v-4.707c0-.26.21-.47.47-.47h2.352V8c0-.26.21-.47.47-.47H7.53V5.646H5.176a.47.47 0 01-.47-.47V.47zM8 4.707h2.353V.94H5.647v3.765H8zm2.353 6.588H15.059v3.765h-4.706v-3.765zm-9.412 0H5.647v3.765H.941v-3.765z",
    fill: "url(#icon-wizzard_svg__paint0_linear_7401_19633)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-wizzard_svg__paint0_linear_7401_19633",
    x1: 0,
    y1: 0,
    x2: 18.754,
    y2: 5.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F26CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97253"
  })))));
}
export default __webpack_public_path__ + "static/icon-wizzard.b4da3408.svg";
export { SvgIconWizzard as ReactComponent };